import { render, staticRenderFns } from "./createproject.vue?vue&type=template&id=10b4c122&scoped=true&"
import script from "./createproject.vue?vue&type=script&lang=js&"
export * from "./createproject.vue?vue&type=script&lang=js&"
import style0 from "./createproject.vue?vue&type=style&index=0&id=10b4c122&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b4c122",
  null
  
)

export default component.exports